import React from 'react';

const BundleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9.239" height="11" viewBox="0 0 9.239 11">
    <g transform="translate(-237 -356.028)">
      <g transform="translate(-637.073 -56.71)">
        <path d="M876.769,419.208v2.64l-.282-.4h-.4l-.367-.45-.264.08v-2.649l-1.38-.818v5.272l4.195,2.487V420.1Z" transform="translate(0 -1.63)"/>
        <path d="M881.654,425.368l4.195-2.487v-5.272l-4.195,2.486Z" transform="translate(-2.537 -1.63)"/>
        <path d="M882.766,415.025l-4.2,2.487,1.627.964,4.195-2.487Z" transform="translate(-1.505 -0.765)"/>
        <path d="M880.155,413.478l-1.249-.74-4.195,2.486,1.249.74Z" transform="translate(-0.214 0)"/>
      </g>
    </g>
  </svg>
);
export default BundleIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/BundleIcon.js